import { createContext } from "react";
const VideosContext = createContext({});
export default VideosContext;
